import script from "./Botao.vue?vue&type=script&setup=true&lang=js"
export * from "./Botao.vue?vue&type=script&setup=true&lang=js"

import "./Botao.vue?vue&type=style&index=0&id=68e536fe&lang=scss"

const __exports__ = script;

export default __exports__